/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * Component SVG Icons
 */
import { ReactComponent as Magic } from "assets/images/icons/components/magic.svg";
import { ReactComponent as Unicorn } from "assets/images/icons/components/alicorn-regular.svg";

// ----------------------------------------------------------------------
// component icons are not used from here anymore - are placed in the DB
// ----------------------------------------------------------------------

// import { ReactComponent as Accordion } from 'assets/images/icons/components/accordion.svg'
// import { ReactComponent as CalendarFeed } from 'assets/images/icons/components/calendar-feed.svg'
// import { ReactComponent as CallToAction } from 'assets/images/icons/components/call-to-action.svg'
// import { ReactComponent as ContentFeed } from 'assets/images/icons/components/content-feed.svg'
// import { ReactComponent as Divider } from 'assets/images/icons/components/divider.svg'
// import { ReactComponent as Documents } from 'assets/images/icons/components/document-list.svg'
// import { ReactComponent as Embed } from 'assets/images/icons/components/embed.svg'
// import { ReactComponent as FeaturedWebpage } from 'assets/images/icons/components/featured-page.svg'
// import { ReactComponent as FeedbackComment } from 'assets/images/icons/components/feedback.svg'
// import { ReactComponent as Form } from 'assets/images/icons/components/form.svg'
// import { ReactComponent as HeadingComponent } from 'assets/images/icons/components/heading.svg'
// import { ReactComponent as HeroComponent } from 'assets/images/icons/components/cp-hero.svg'
// import { ReactComponent as HeroCarousel } from 'assets/images/icons/components/hero-carousel.svg'
// import { ReactComponent as IconLinkList } from 'assets/images/icons/components/icon-links-list.svg'
// import { ReactComponent as ImageComponent } from 'assets/images/icons/components/image-component.svg'
// import { ReactComponent as ImageGallery } from 'assets/images/icons/components/image-gallery.svg'
// import { ReactComponent as ImageList } from 'assets/images/icons/components/image-list.svg'
// import { ReactComponent as ImageListComponent } from 'assets/images/icons/components/image-list-component.svg'
// import { ReactComponent as InfoBox } from 'assets/images/icons/components/infobox.svg'
// import { ReactComponent as InfoBoxComponent } from 'assets/images/icons/components/info-box.svg'
// import { ReactComponent as LinkButton } from 'assets/images/icons/components/link-button.svg'
// import { ReactComponent as LinkList } from 'assets/images/icons/components/link-list.svg'
// import { ReactComponent as NavigationList } from 'assets/images/icons/components/navigation-list.svg'
// import { ReactComponent as PermitSelect } from 'assets/images/icons/components/clipboard-with-question-mark.svg'
// import { ReactComponent as PermitListAuth } from 'assets/images/icons/components/clipboard-with-person.svg'
// import { ReactComponent as Quote } from 'assets/images/icons/components/quote-right-solid.svg'
// import { ReactComponent as RichText } from 'assets/images/icons/components/text-solid.svg'
// import { ReactComponent as RichTextComponent } from 'assets/images/icons/components/rich-text.svg'
// import { ReactComponent as TableOfContents } from 'assets/images/icons/components/table-of-contents.svg'
// import { ReactComponent as TabFolder } from 'assets/images/icons/components/tabs-component.svg'
// import { ReactComponent as TextWithImage } from 'assets/images/icons/components/text-with-image.svg'
// import { ReactComponent as Table } from 'assets/images/icons/components/table-regular.svg'
// import { ReactComponent as Timeline } from 'assets/images/icons/components/navigation-list.svg'
// import { ReactComponent as TimelineComponent } from 'assets/images/icons/components/cp-timeline.svg'
// import { ReactComponent as Youtube } from 'assets/images/icons/components/video.svg'

const components = {
    Magic,
    Unicorn,
};

export { components };
